import { configureRestApiClient } from '@confluence-classic/confluence-rest-api-client';

export function subscribe(store) {
	store.subscribe(() => {
		configureRestApiClient(store);
	});
	configureRestApiClient(store);
}
